import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { SigmaJwtClient } from '../../auth/sigma-jwt';

export const useSigmaJwt = () => {
  const auth0 = useAuth0();

  const sigmaJwtClient = new SigmaJwtClient(auth0);

  const sigmaJwt = useQuery({
    queryKey: ['sigmaJwt'],
    queryFn: sigmaJwtClient.generateSigmaJwt,
  });

  return {
    sigmaJwt,
  };
};
